import React from "react";




function Experience() {
    return (

        <div id="experienceBack">
                <div className="container" >

                <div className="row text-center justify-content-center mb-5">
        <div className="col-xl-6 col-lg-8">
            <h1 className="aboutmetxt" id="experience">My Experience</h1>
            {/* <p className="text-muted">
            I am a versatile designer with extensive expertise in Graphic Design, UX & UI Design, and Multimedia Design. My experience spans a wide range of design disciplines, including Motion Graphic Design, where I craft engaging visual content that communicates effectively and captivates audiences. My skills and knowledge enable me to deliver creative and impactful solutions across various design mediums.</p> 
                 */}
                {/* I start my experice working as a Web developer in Konecta where I've been working with HTML and CSS changing content in a bank from Spain. After that I got a job with a recognise photographer called Jorge Amado, I help him to design his magazine showing his pictures (programs I used Adobe Illustrator, Photoshop, Indisgin). Not longer I finish the magazine I got a job opportunity as a Tutor in edition and Postproduction at the University where I gradueted, where I've been teaching how to use programs like Adobe Premiere, Adobe After Effects, Adobe Photoshop, Adobe Illustrator, Mocha, Particle illusion. I shared my last year of teaching working for a TV channel where I've been the responsable to create the new graphic identity of the TV News, for the long of 2 years I've been designing graphics, animations and working in the website and social medias.  */}
        </div>
    </div>
                      <div className="main-timeline">



   
<div className="timeline">
  <div className="icon"></div>
  <div className="date-content">
    <div className="date-outer">
      <span className="date">
        <span className="month">Feb. 2023</span>
        <span className="year" id="year2">Current</span>
      </span>
    </div>
  </div>
  <div className="timeline-content">
    <h5 className="title">Graphic Designer & Web Developer</h5>
    <p className="description">
      <b>Event Merchandise Services (EMS)</b><br />
      • Redesign and program websites using React, WordPress, and Shopify.<br />
      • Website maintenance, content creation, and section development.<br />
      • Photography of new products and photo editing.<br />
      • Social media management and content updates.<br />
      • Design of large-format print materials for merchandising and branding at major sporting events such as FIFA Women’s World Cup 2023, NZR, and the All Blacks.<br />
      • Responsible for visual design of pop-up shops, trailers, and containers at stadiums including Whangarei – Semenoff Stadium, Dunedin – Forsyth Barr Stadium, Wellington – Sky Stadium, Hamilton – FMG Stadium Waikato, and Eden Park in Auckland.<br />
      • Design all kinds of materials needed like posters, business cards, and printing for physical business setups.<br />
    </p>
    <br/>
    <b>Websites created:</b><br />
    <a href="https://www.eventmerchandise.co.nz" target="_blank" rel="noopener noreferrer">www.eventmerchandise.co.nz</a> |{' '}
    <a href="https://www.sekem.co.nz" target="_blank" rel="noopener noreferrer">www.sekem.co.nz</a> |{' '}
    <a href="https://shop.nzfootball.co.nz/" target="_blank" rel="noopener noreferrer">www.shop.nzfootball.co.nz</a> |{' '}
    <a href="https://sportsfan.co.nz/" target="_blank" rel="noopener noreferrer">www.sportsfan.co.nz</a><br />
 
  </div>
</div>

<div className="timeline">
  <div className="icon"></div>
  <div className="date-content">
    <div className="date-outer">
      <span className="date">
        <span className="month">Feb. 2023</span>
        <span className="year" id="year2">Current</span>
      </span>
    </div>
  </div>
  <div className="timeline-content">
    <h5 className="title">Graphic Designer & Web Developer</h5>
    <p className="description">
      <b>Kiwikrane</b><br />
      • Redesign and program websites using React, WordPress, and Shopify.<br />
      • Website maintenance, content creation, and section development.<br />
      • Photography of new products and photo editing.<br />
      • Create and design websites, logos, and graphic identities for partner companies.<br />
      • Social media management and content updates.<br />
      • Design materials such as posters, business cards, etc.<br />
      <br />
      <b>Websites created:</b><br />
      <a href="https://www.shop.kiwikrane.co.nz" target="_blank" rel="noopener noreferrer">www.shop.kiwikrane.co.nz</a> |{' '}
      <a href="https://www.kiwikrane.co.nz" target="_blank" rel="noopener noreferrer">www.kiwikrane.co.nz</a> |{' '}
      <a href="https://www.kiwikrane.dearportal.com" target="_blank" rel="noopener noreferrer">www.kiwikrane.dearportal.com</a> |{' '}
      <a href="https://www.cardcentral.co.nz" target="_blank" rel="noopener noreferrer">www.cardcentral.co.nz</a><br />
      <a href="https://www.ballsnallvending.co.nz" target="_blank" rel="noopener noreferrer">www.ballsnallvending.co.nz</a> |{' '}
      <a href="https://www.laundrymates.co.nz" target="_blank" rel="noopener noreferrer">www.laundrymates.co.nz</a> |{' '}
      <a href="https://www.kranestation.co.nz" target="_blank" rel="noopener noreferrer">www.kranestation.co.nz</a> |{' '}
      <a href="https://www.partyclaw.nz" target="_blank" rel="noopener noreferrer">www.partyclaw.nz</a><br />
    </p>
  </div>
</div>

<div className="timeline">
  <div className="icon"></div>
  <div className="date-content">
    <div className="date-outer">
      <span className="date">
        <span className="month">Jul. 2024</span>
        <span className="year" id="year2">Jul. 2025</span>
      </span>
    </div>
  </div>
  <div className="timeline-content">
    <h5 className="title">Web & Graphic Designer</h5>
    <p className="description">
      <b>MacroActive</b><br />
      • Specializing in apps and websites for personal trainers.<br />
      • Logo design and brand identity development.<br />
      • Website creation using DUDA.<br />
      • Advertising and promotional materials design.<br />
      • Banner design.<br />
      <br />
      <b>Websites created:</b><br />
      <a href="https://www.ironanthologyonline.com" target="_blank" rel="noopener noreferrer">www.ironanthologyonline.com</a> |{' '}
      <a href="https://www.liftwithlyss.com" target="_blank" rel="noopener noreferrer">www.liftwithlyss.com</a> |{' '}
      <a href="https://www.getstarted.snatchbackyoursexy.com" target="_blank" rel="noopener noreferrer">www.getstarted.snatchbackyoursexy.com</a> |{' '}
      <a href="https://www.emmafit.co.nz" target="_blank" rel="noopener noreferrer">www.emmafit.co.nz</a><br />
      <a href="https://www.getstarted.unboundathletic.com.au" target="_blank" rel="noopener noreferrer">www.getstarted.unboundathletic.com.au</a> |{' '}
      <a href="https://www.healthylifebalance.net" target="_blank" rel="noopener noreferrer">www.healthylifebalance.net</a> |{' '}
      <a href="https://www.skulptwellness.com" target="_blank" rel="noopener noreferrer">www.skulptwellness.com</a> |{' '}
      <a href="https://www.shiftbody.co.uk" target="_blank" rel="noopener noreferrer">www.shiftbody.co.uk</a><br />
      <a href="https://www.creandobalanceonline.com" target="_blank" rel="noopener noreferrer">www.creandobalanceonline.com</a> |{' '}
      <a href="https://www.couragefit.app" target="_blank" rel="noopener noreferrer">www.couragefit.app</a> |{' '}
      <a href="https://www.becomingnotorious.com" target="_blank" rel="noopener noreferrer">www.becomingnotorious.com</a> |{' '}
      <a href="https://www.lawlessphysiques.com" target="_blank" rel="noopener noreferrer">www.lawlessphysiques.com</a><br />
      <a href="https://www.mpowerperformance.net" target="_blank" rel="noopener noreferrer">www.mpowerperformance.net</a><br />
    </p>
  </div>
</div>





{/* 
                      <div className="timeline">
    <div className="icon"></div>
    <div className="date-content">
        <div className="date-outer">
            <span className="date">
                <span className="month">Current</span>
                <span className="year" id="year2">2023</span>
            </span>
        </div>
    </div>
    <div className="timeline-content">
        <h5 className="title">Web Developer & Multimedia Designer</h5>
        <p className="description">
            <b>Feb. 2023 - Current | Event Merchandise Service</b> <br />
            Redesign and develop websites using React and Shopify.<br />
            Maintain websites, create content, and build new sections.<br />
            Photograph new products, edit photos, and publish product listings.<br /><br />

            <b>Multimedia Designer for Events</b><br />
            Designed merchandise stores for major football stadiums in New Zealand for the FIFA Women's World Cup, including Eden Park, Hamilton, and Sky Stadium in Wellington.<br />
            Created print designs for trailers and storefronts for merchandising.<br /><br />

            <b>Websites Created</b><br />
            - New Zealand Football<br />
            - New Zealand Cricket<br />
            - New Zealand Netball<br />
            - New Zealand Rugby League<br />
            - SEKEM<br />
            - Event Merchandise Service<br />
            <br /><i><u>Programs Used:</u> Adobe Photoshop, Adobe Illustrator, Adobe InDesign<br />
            <u>Programming:</u> HTML, CSS, JavaScript, TypeScript, Liquid, React, Shopify, WordPress, WooCommerce</i>
        </p>
    </div>
</div>



                        <div className="timeline">
                            <div className="icon"></div>
                            <div className="date-content">
                                <div className="date-outer">
                                    <span className="date">
                                        <span className="month">Current</span>
                                        <span className="year" id="year2">2023</span>
                                    </span>
                                </div>
                            </div>

                            <div className="timeline-content">
                                <h5 className="title">Web Developer & Graphic Designer</h5>
                                <p className="description">
                                    <b>Feb. 2023 - Current | KiwiKrane</b> <br />
                                    Redesign and program website in React<br />
                                    Website maintenance, content creation, and sections creation.<br />
                                    Photography of new products, photo editing, and product publication.<br />
                                    Create and design websites, logos, graphic identities, and print designs for companies working in association with KiwiKrane.<br />
                                    <br /><i><u>Programs used:</u> Adobe Photoshop, Adobe Illustrator, Adobe InDesign<br />
                                    <u>Programming:</u> HTML, CSS, JavaScript, React, Shopify</i>
                                </p>
                            </div>
                        </div> */}



                        <div className="timeline">
                            <div className="icon"></div>
                            <div className="date-content">
                                <div className="date-outer">
                                    <span className="date">
                                            <span className="month">1.5 Years</span>
                                    <span className="year" id="year2">2021-2023</span>
                                    </span>
                                </div>
                            </div>
                            <div className="timeline-content">
                                <h5 className  ="title">Multimedia Designer</h5>
                                <p className="description">
                                <b>Sept. 2021 - Feb. 2023 | Good Feeling Ltd</b> <br />
                                Design of company brand <br />
                                Graphics and photography for social media (Instagram and Facebook) <br />
                                UX and web design <br />
                                Motion graphics 
                                <br /><i><u>Programs used:</u> Adobe Photoshop, Adobe Illustrator, Adobe Premiere, Adobe After Effects.
                                <br /><u>Programming:</u> HTML, CSS, JavaScript</i></p>
                            </div>
                        </div>
                  
                        {/* <div className="timeline">
                            <div className="icon"></div>
                            <div className="date-content">
                                <div className="date-outer">
                                    <span className="date">
                                            <span className="month">Freelance</span>
                                    <span className="year">2022</span>
                                    </span>
                                </div>
                            </div>
                            <div className="timeline-content">
                                <h5 className="title">UX, UI Designer & Web Developer</h5>
                                <p className="description">
                                <b>Oct. - Dec. 2022 | Sophie Dyson</b> <br />
                                    Created personal brand, logo & website 
                                <br /><i><u>Programs used:</u> Adobe Photoshop, Adobe Illustrator
                                <br /><u>Programming:</u> HTML, CSS, JavaScript, React, Bootstrap, Emailjs, Node.js </i></p>
                            </div>
                        </div> */}
                 
                        <div className="timeline">
                            <div className="icon"></div>
                            <div className="date-content">
                                <div className="date-outer">
                                    <span className="date">
                                            <span className="month">2 Years</span>
                                    <span className="year" id="year2">2020-2021</span>
                                    </span>
                                </div>
                            </div>
                            <div className="timeline-content">
                                <h5 className="title">Graphic Designer</h5>
                                <p className="description">
                                <b>June 2020 - Aug. 2021 | South America Oven</b> <br />
                                Graphic design such as menus, advertisements and shop signage<br />
                                Video creation and editing for promotions
                                <br /><i><u>Programs used:</u> Adobe Photoshop, Adobe Illustrator, Adobe Premiere, Adobe After Effects
                                <br /><u>Programming:</u> HTML, CSS </i></p>
                            </div>
                        </div>



<div className="timeline">
    <div className="icon"></div>
    <div className="date-content">
        <div className="date-outer">
            <span className="date">
                <span className="month">Freelance</span>
                <span className="year">2019</span>
            </span>
        </div>
    </div>
    <div className="timeline-content">
        <h5 className="title">Motion Graphic Designer</h5>
        <p className="description">
            <b>Dec. 2019 – Jan. 2020 | Sky TV Network</b> <br />
            Temporary licence cover. Contributed to the creation of video promotions for the sports channel and social media platforms. Designed and animated a Christmas-themed motion graphic piece for a children’s program. Also supported the production of promotional materials across various formats.
            <br /><i><u>Programs used:</u> Adobe Photoshop, Adobe Illustrator, Adobe Premiere, Adobe After Effects</i>
        </p>
    </div>
</div>






                         <div className="timeline">
    <div className="icon"></div>
    <div className="date-content">
        <div className="date-outer">
            <span className="date">
                <span className="month">2 years</span>
                <span className="year" id="year2">2013-2015</span>
            </span>
        </div>
    </div>
    <div className="timeline-content">
        <h5 className="title">Motion Graphic Designer</h5>
        <p className="description">
            <b>Oct. 2013 - Oct. 2015 | Televisa/Channel 9</b> <br />
            Multimedia design including video creation, motion graphics, postproduction and FX. <br />
            Design of company brand. <br />
            New opening animation for the television station. <br />
            Graphic design such as logos and stills. <br />
            Graphic design pieces created specifically for animation and distribution across television and social media platforms.
            <br /><i><u>Programs used:</u> Adobe Photoshop, Adobe Illustrator, Adobe Premiere, Adobe After Effects, Cinema 4D
            <br /><u>Programming:</u> HTML, CSS</i>
        </p>
    </div>
</div>

            
                        {/* <div className="timeline">
                            <div className="icon"></div>
                            <div className="date-content">
                                <div className="date-outer">
                                    <span className="date">
                                            <span className="month">2 Years</span>
                                    <span className="year" id='year2'>2018-2020</span>
                                    </span>
                                </div>
                            </div>
                            <div className="timeline-content">
                                <h5 className="title">Graphic Designer & Motion Graphics</h5>
                                <p className="description">
                                <b>Jan. 2018 - March 2020 | Insomniak Records</b> <br />
                                Visual animation during live events <br />
                                Graphics for advertisements
                                <br /><i><u>Programs used:</u> Adobe Photoshop, Adobe Illustrator, Adobe Premiere, Adobe After Effects, Resolume</i></p>
                            </div>
                        </div> */}

                        {/* <div className="timeline">
                            <div className="icon"></div>
                            <div className="date-content">
                                <div className="date-outer">
                                    <span className="date">
                                            <span className="month">Freelance</span>
                                    <span className="year">2019</span>
                                    </span>
                                </div>
                            </div>
                            <div className="timeline-content">
                                <h5 className="title">Motion Graphic Designer</h5>
                                <p className="description">
                                <b>Dic. 2019 - Ene. 2020 | Sky TV Network.</b> <br />
                                Licence covered. Video promotions for the sports channel, social media, graphic support and promotions for childrens programs
                                <br /><i><u>Program used:</u> Adobe Photoshop, Adobe Illustrator, Adobe Premiere, Adobe After Effects</i></p>
                            </div>
                        </div> */}

                        {/* <div className="timeline">
                            <div className="icon"></div>
                            <div className="date-content">
                                <div className="date-outer">
                                    <span className="date">
                                            <span className="month">Freelancer</span>
                                    <span className="year">2015</span>
                                    </span>
                                </div>
                            </div>
                            <div className="timeline-content">
                                <h5 className="title">Multimedia Designer</h5>
                                <p className="description">
                                <b>May - Dec. 2015 | Osiris Events</b> <br />
                                Design of company brand <br /> Promotional material for advertisements <br /> Animation <br /> Photography for live events
                                <br /><i><u>Programs used:</u> Adobe Photoshop, Adobe Illustrator, Adobe Premiere, Adobe After Effects, Cinema 4D</i>
                                </p>
                            </div>
                        </div>

                       

                        {/* <div className="timeline">
                            <div className="icon"></div>
                            <div className="date-content">
                                <div className="date-outer">
                                    <span className="date">
                                            <span className="month">3 years</span>
                                    <span className="year">2012</span>
                                    </span>
                                </div>
                            </div>
                            <div className="timeline-content">
                                <h5 className="title">Audiovisual Tutor</h5>
                                <p className="description">
                                <b>Feb. 2012 - Dic. 2014 | Da Vinci Multimedia Art School</b> <br />
                                Audiovisual edition, post-production and motion graphics (Adobe After Effects, Adobe Premiere, Mocha and Particle Illusion)
                                <br /><i><u>Program used:</u> Adobe Photoshop, Adobe Illustrator, Adobe Indesgin</i></p>
                            </div>
                        </div> */}

                        {/* <div className="timeline">
                            <div className="icon"></div>
                            <div className="date-content">
                                <div className="date-outer">
                                    <span className="date">
                                            <span className="month">2 years</span>
                                    <span className="year">2011</span>
                                    </span>
                                </div>
                            </div>
                            <div className="timeline-content">
                                <h5 className="title">Graphic Designer</h5>
                                <p className="description">
                                <b>Feb. 2011 - Dic. 2012 | J.A.G</b> <br />
                                Photo retouching,
                                Layout and design magazines like Intercountries, Vea más.
                                Design of advertisements.
                                <br /><i><u>Program used:</u> Adobe Photoshop, Adobe Illustrator, Adobe Indisgin</i></p>
                            </div>
                        </div> */}

                        {/* <div className="timeline">
                            <div className="icon"></div>
                            <div className="date-content">
                                <div className="date-outer">
                                    <span className="date">
                                            <span className="month">2 years</span>
                                    <span className="year">2011</span>
                                    </span>
                                </div>
                            </div>
                            <div className="timeline-content">
                                <h5 className="title">Web Maintenance</h5>
                                <p className="description">
                                <b>Ene. 2010 - Dic. 2011 | Grupo Konecta</b> <br />
                                Maintenance Web at Santander Río Bank, and updates pressroom.
                                <br /> <i><u>programming:</u> HTML, CSS </i></p>
                            </div>
                        </div> */}


                    </div>
                </div>
            </div>   
    
                
    )
};

export default Experience;




